(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-tab-with-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tab-link').forEach(function(tab) {
    tab.addEventListener('click', function () {
      
      const tabID = this.getAttribute('data-tab');

      // Remove active class from all tab links
      document.querySelectorAll('.tab-link').forEach(function(el) {
        el.classList.remove('active');
      });

      // Add active class to clicked tab
      this.classList.add('active');

      // Remove active class from all tab contents
      document.querySelectorAll('[id^="tab-"]').forEach(function(el) {
        el.classList.remove('active');
      });

      // Add active class to selected tab content
      document.getElementById('tab-' + tabID).classList.add('active');

    });
  });


  const items = document.querySelectorAll('.accordion button');
  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }

  items.forEach((item) => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();
})();
